import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ContentBlock, MainTitle } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import DeansOfficeGeneralInformation from './DeansOfficeGeneralInformation.jsx';
import WorkplaceGeneralInformation from './WorkplaceGeneralInformation.jsx';
import WorkplaceEmployeesAndStudents from './WorkplaceEmployeesAndStudents.jsx';
import WorkplaceDescription from './WorkplaceDescription.jsx';

function DepartmentDetail({ department }) {
  const { i18n } = useTranslation();

  const isDeansOffice = useMemo(
    () => department.code.toLowerCase() === 'dekanat',
    [department.code],
  );

  // Set page title to department/workplace name
  useEffect(() => {
    if (!department) return;
    const title =
      i18n.language === 'en' ? department.title_en : department.title_sk;
    if (title) document.title = title;
  }, [i18n.language, department?.title_en, department?.title_sk]);

  return (
    <div className="custom-page-dynamic-container department-container ant-collapsible-remove-x-padding">
      <ContentBlock
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        contentVisible
      >
        <MainTitle
          title={
            i18n.language === 'en' ? department.title_en : department.title_sk
          }
        />

        {isDeansOffice ? (
          <DeansOfficeGeneralInformation department={department} />
        ) : (
          <div className="add-icons-to-file-anchors">
            <WorkplaceGeneralInformation department={department} />
            <WorkplaceEmployeesAndStudents department={department} />
            <WorkplaceDescription department={department} />
            {/*<WorkplaceActivities department={department} />*/}
          </div>
        )}
      </ContentBlock>
    </div>
  );
}

DepartmentDetail.propTypes = {
  department: PropTypes.object,
};

export default DepartmentDetail;
